import { OrderSummary } from "../shared/order-summary";
import { ShipToAddressRead } from "../../../shared/models/ship-to-address-read";
import { DeliveryShipmentActionCreate } from "./_index";

export class DeliveryShipmentActionCreateFull extends DeliveryShipmentActionCreate {

    // Some properties to facilitate passing data around components.
    // These aren't sent in the request.

    public address : ShipToAddressRead;

    public openOrders : OrderSummary[];

}
